export default {
  stocks: {
    is: 'Hlutabréf',
    en: 'Stocks',
  },
  nasdaq: {
    is: 'Kauphöll Íslands',
    en: 'Nasdaq OMX Iceland',
  },
  disclaimer: {
    is: 'Kauphöll Íslands | Upplýsingar eru a.m.k. 15 mínútna gamlar',
    en: 'Nasdaq OMX Iceland | Data delayed by 15 min.',
  },
  marketToday: {
    is: 'Aðalmarkaður',
    en: 'Aðalmarkaður',
  },
  firstNorth: {
    is: 'First North',
    en: 'First North',
  },
  trades: {
    is: 'Viðskipti dagsins',
    en: 'Today’s trades',
  },
  company: {
    is: 'Félag',
    en: 'Company',
  },
  price: {
    is: 'Gengi',
    en: 'Price',
  },
  change: {
    is: 'Br. í dag',
    en: 'Ch. today',
  },
  bid: {
    is: 'Kaup',
    en: 'Bid',
  },
  ask: {
    is: 'Sala',
    en: 'Ask',
  },
  value: {
    is: 'Virði',
    en: 'Value',
  },
  quantity: {
    is: 'Fjöldi hluta',
    en: 'Number of shares',
  },
  turnover: {
    is: 'Velta (þús. ISK)',
    en: 'Turnover (ISK thousand)',
  },
  time: {
    is: 'Tími',
    en: 'Time',
  },
  numberOfTrades: {
    is: 'Fjöldi',
    en: 'No.',
  },
  Highest: {
    is: 'Hæsta',
    en: 'Highest',
  },
  Lowest: {
    is: 'Lægsta',
    en: 'Lowest',
  },
  buy: {
    is: 'Kaupa',
    en: 'Buy',
  },
  selectInformation: {
    is: 'Veldu upplýsingar',
    en: 'Select information',
  },
};
